<script setup lang="ts">
import BaseSvg from '@clovyr/bed/components/icons/BaseSvg.vue';
</script>

<template>
  <BaseSvg class="icon icon-how-to" width="23" height="24" viewBox="0 0 23 24" fill="none">
    <g clip-path="url(#a)">
      <path
        fill="currentcolor"
        d="M22.71 13.38a.9.9 0 0 0-1.28-.08l-10.07 8.84c-.35.31-.89.38-1.34.2l-7.78-3.27c-.25-.12-.42-.32-.42-.56V16.7l7.55 3.16a3.14 3.14 0 0 0 3.23-.5l9.65-8.47a.92.92 0 0 0 .09-1.3.9.9 0 0 0-1.29-.08l-9.64 8.46c-.36.3-.89.38-1.34.18l-7.79-3.26c-.25-.1-.42-.32-.42-.55v-1.78l7.2 3.23a2.3 2.3 0 0 0 2.49-.38l9.19-8.17a2.27 2.27 0 0 0-.61-3.8L12.79.2a2.3 2.3 0 0 0-2.42.34L.83 8.49c-.61.5-.91 1.28-.8 2.06 0 .06.03.11.04.16l-.02 3.17s-.03.07-.03.12L0 18.5c0 .98.6 1.87 1.54 2.26l7.8 3.26a3.14 3.14 0 0 0 3.23-.5l10.06-8.83a.92.92 0 0 0 .08-1.3Z"
      />
    </g>
    <defs>
      <clipPath id="a">
        <path fill="#fff" d="M0 0h22.68v24H0z" />
      </clipPath>
    </defs>
  </BaseSvg>
</template>
